export default __webpack_public_path__ + "static/media/linet_logo_color_rgb.658954a9.svg";